// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetRequestFormsRequestModel from '../../model/get-request-forms-request-model';
import GetRequestFormsRequestDTO from '../dto/get-request-forms-request-dto';
import dtoSchema from '../schemas/get-request-forms-request-schema';

export default abstract class GetRequestFormsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetRequestFormsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.from = data.from;
      this.until = data.until;
      this.type = data.type;
      this.subType = data.subType;
      this.state = data.state;
      this.paymentType = data.paymentType;
      this.paymentState = data.paymentState;
      this.reminderState = data.reminderState;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {date-time}
  */
  from?: string;
  /**
  * @type {date-time}
  */
  until?: string;
  /**
  */
  type?: string;
  /**
  */
  subType?: string;
  /**
  */
  state?: boolean;
  /**
  */
  paymentType?: string;
  /**
  */
  paymentState?: string;
  /**
  */
  reminderState?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetRequestFormsRequestDTO>): GetRequestFormsRequestModel;
  static toModel(dto: DeepPartial<GetRequestFormsRequestDTO> | undefined | null): GetRequestFormsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetRequestFormsRequestDTO> | undefined | null): GetRequestFormsRequestModel | undefined {
    return dto ? new GetRequestFormsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetRequestFormsRequestModel> | GetRequestFormsRequestModel): GetRequestFormsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      from: unwrapped.from,
      until: unwrapped.until,
      type: unwrapped.type,
      subType: unwrapped.subType,
      state: unwrapped.state,
      paymentType: unwrapped.paymentType,
      paymentState: unwrapped.paymentState,
      reminderState: unwrapped.reminderState,
      searchCriteria: unwrapped.searchCriteria,
    } as GetRequestFormsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetRequestFormsRequestModel, can not map to GetRequestFormsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
